import {Component} from '@angular/core';
import {AuthWrapperComponent} from "../auth-wrapper/auth-wrapper.component";
import {FormInputComponent} from "../../utils/form-input/form-input.component";
import {MdbButtonComponent} from "../../utils/mdb-button/mdb-button.component";
import {AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {environment} from '../../../../environments/environment';
import {MdbValidationModule} from "mdb-angular-ui-kit/validation";


@Component({
    selector: 'app-reset-password',
    imports: [
    AuthWrapperComponent,
    FormInputComponent,
    MdbButtonComponent,
    ReactiveFormsModule,
    TranslateModule,
    MdbValidationModule
],
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  loading: boolean = false
  formGroup: FormGroup = this.formBuilder.group(
    {
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required, Validators.minLength(environment.passwordMinLength)]],
      confirmPassword: [null, [Validators.required]]
    },
    {
      validators: this.matchValidator('password', 'confirmPassword')
    }
  )

  constructor(private formBuilder: FormBuilder) {
  }

  getFormControl(name: string): AbstractControl | null {
    return this.formGroup.get(name)
  }

  submit() {
    this.formGroup.markAllAsTouched()

    if (this.formGroup.invalid)
      return

    this.loading = true
    // this.authService.login(this.getFormControl('username')?.value, this.getFormControl('password')?.value)
    //   .pipe(finalize(() => this.loading = false))
    //   .subscribe({
    //     next: (machine) => {
    //       this.router.navigate(['../']);
    //     },
    //     error: (e: HttpErrorResponse) => {
    //       console.log("Login error:")
    //       console.log(e)
    //
    //       this.notificationService.error("Machine could not be created.")
    //     }
    //   })
  }

  matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
    return (abstractControl: AbstractControl) => {
      const control = abstractControl.get(controlName);
      const matchingControl = abstractControl.get(matchingControlName);

      if (matchingControl!.errors && !matchingControl!.errors?.['confirmedValidator']) {
        return null;
      }

      if (control!.value !== matchingControl!.value) {
        const error = {confirmedValidator: 'Passwords do not match.'};
        matchingControl!.setErrors(error);
        return error;
      } else {
        matchingControl!.setErrors(null);
        return null;
      }
    }
  }

  protected readonly environment = environment;
  protected readonly console = console;
}
